import { X } from "lucide-react";

type Props = {
  onDismiss: () => void;
};

export function DeletedLeadsBanner({ onDismiss }: Props): React.JSX.Element {
  return (
    <div className="flex items-center justify-between gap-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3">
      <p className="text-sm text-amber-800">
        Mostrando leads eliminados. Estos leads no aparecen en el tablero.
      </p>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Cerrar aviso"
        className="flex-shrink-0 text-amber-600 hover:text-amber-800 cursor-pointer"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
